/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * The blank onboarding template, base64-encoded, plus the name to save it under.
 * @export
 * @interface SavedCommoditiesTemplateResponse
 */
export interface SavedCommoditiesTemplateResponse {
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesTemplateResponse
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesTemplateResponse
   */
  base64Data: string;
}

/**
 * Check if a given object implements the SavedCommoditiesTemplateResponse interface.
 */
export function instanceOfSavedCommoditiesTemplateResponse(
  value: object,
): value is SavedCommoditiesTemplateResponse {
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  if (!("base64Data" in value) || value["base64Data"] === undefined)
    return false;
  return true;
}

export function SavedCommoditiesTemplateResponseFromJSON(
  json: any,
): SavedCommoditiesTemplateResponse {
  return SavedCommoditiesTemplateResponseFromJSONTyped(json, false);
}

export function SavedCommoditiesTemplateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedCommoditiesTemplateResponse {
  if (json == null) {
    return json;
  }
  return {
    fileName: json["fileName"],
    base64Data: json["base64Data"],
  };
}

export function SavedCommoditiesTemplateResponseToJSON(
  json: any,
): SavedCommoditiesTemplateResponse {
  return SavedCommoditiesTemplateResponseToJSONTyped(json, false);
}

export function SavedCommoditiesTemplateResponseToJSONTyped(
  value?: SavedCommoditiesTemplateResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fileName: value["fileName"],
    base64Data: value["base64Data"],
  };
}
